// Цвета проектов: палитра старого Release Plan. Новому проекту цвет достаётся хешем от id — так же,
// как старое приложение красило проекты, поэтому перенесённые проекты выглядят как раньше.
export const PROJECT_PALETTE = ['#FF9D04', '#50B5FF', '#E9B663', '#E74C3C', '#00B5A0', '#6C5CE7', '#1F9953', '#535A66'] as const;
/** Серый из палитры: default колонки project.color (0009) и проект, которого нет. */
export const DEFAULT_PROJECT_COLOR = PROJECT_PALETTE[7];

/** Хеш старого приложения: h = h*31 + code в int32, abs, mod 8. Совпадает с бэкфиллом миграции 0009. */
export function paletteColorOf(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  return PROJECT_PALETTE[Math.abs(h) % PROJECT_PALETTE.length]!;
}

/**
 * Относительная яркость по sRGB (WCAG): 0 — чёрный, 1 — белый. Принимает #rgb и #rrggbb; мусор — 0.
 */
export function luminance(hex: string): number {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return 0;
  const h = m[1]!.length === 3 ? m[1]!.split('').map((c) => c + c).join('') : m[1]!;
  const ch = (i: number) => { const c = parseInt(h.slice(i, i + 2), 16) / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; };
  return 0.2126 * ch(0) + 0.7152 * ch(2) + 0.0722 * ch(4);
}

export const INK_DARK = '#101420';
export const INK_LIGHT = '#ffffff';
/**
 * Цвет текста на заливке: светлая — тёмные чернила, тёмная — белые. Порог 0.3 подобран по палитре
 * проектов и цветам людей с боя: жёлтый, бежевый, салатовый и мятный получают тёмный текст, синий,
 * красный, зелёный и фиолетовый — белый (точка равного контраста ≈ 0.18, но привычнее белое на насыщенном). У градиента двух исполнителей — по более светлой половине.
 */
export const inkOn = (...backgrounds: string[]): string => (Math.max(...backgrounds.map(luminance)) > 0.3 ? INK_DARK : INK_LIGHT);
